import VDINotAvailable from "./components/VDI_NotAvailable.vue";
import VDIRegistrationForm from "./components/VDI_Register.vue";
import VDIUnregistrationForm from "./components/VDI_Unregister.vue";



export const routes = [
  { path: "/register", component: VDIRegistrationForm, name: "VDIRegistrationForm" },
  { path: "/Deny", component: VDINotAvailable, name: "VDINotAvailable" },
  { path: "/Unregister", component: VDIUnregistrationForm, name: "VDIUnregistrationForm" }
];
